import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';

const ACTIVITY_LOG_SETTINGS_PREFIX = 'activity-log-settings';

export const activityLogSettingsGroupContainer = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'group-container', {
    paddingTop: CommonStyles.Sizes.LargeSpace
});

export const activityLogToggleButtonContainer = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'toggle-btn-container', {
    maxWidth: '175px',
    display: 'block'
});

export const activityLogConnectionSetupDialogBlock = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'dialog-block', {
    display: 'block',
    paddingBottom: CommonStyles.Sizes.DefaultSpace,
    paddingLeft: CommonStyles.Sizes.MediumSpace,
    paddingRight: CommonStyles.Sizes.LargeSpace
});

export const activityLogConnectionSetupDialogComponent = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'dialog-component', {
    display: 'inline',
    paddingRight: CommonStyles.Sizes.MediumSpace
});

export const activityLogSettingsDescription = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'text-description', {
    paddingBottom: CommonStyles.Sizes.LineHeight,
    fontSize: CommonStyles.Sizes.NormalFontSize,
    margin: 0
  });

export const activityLogConnectionSetupSpacer = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'spacer', {
    paddingBottom: CommonStyles.Sizes.MediumSpace
});

export const activityLogConnectionSetupButtons = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'buttons', {
    float: 'right',
    marginBottom: CommonStyles.Sizes.SmallSpace
});

export const activityLogConnectionCancelButton = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'cancel-btn', {
    display: 'inline',
    paddingRight: CommonStyles.Sizes.MediumSpace
});

export const activityLogConnectionSetupTextFieldSpacer = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'text-field-spacer', {
    paddingBottom: CommonStyles.Sizes.LineWidth
});

export const activityLogConnectionSetupTextFieldSize = 45;

export const activityLogStatusTableHeader = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'table-header', {
    height: CommonStyles.Sizes.DataGridHeaderHeight,
    borderTopWidth: CommonStyles.Sizes.LineWidth,
    borderTopColor: CommonStyles.Colors.DividerLineColor,
    borderTopStyle: 'solid',
    borderBottomWidth: CommonStyles.Sizes.LineWidth,
    borderBottomColor: CommonStyles.Colors.DividerLineColor,
    borderBottomStyle: 'solid',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: CommonStyles.Colors.Grey250,
    borderSpacing: 0
});

export const activityLogStatusTable = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'table', {
    borderSpacing: 0,
    textAlign: 'left',
    backgroundColor: TabStyles.Colors.White,
    cursor: 'default',
    width: '1000px',
});

export const activityLogConnectionStatusPadding = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'table-padding', {
    paddingTop: CommonStyles.Sizes.XLargeSpace,
    paddingBottom: CommonStyles.Sizes.XLargeSpace
});

export const activityLogVerificationContainer = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'verification-group-container', {
    paddingBottom: CommonStyles.Sizes.DefaultSpace,
    fontSize: CommonStyles.Sizes.SmallFontSize
});

export const activityLogVerificationRow = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'verification-group-row', {
    display: 'flex',
    alignItems: 'center',
    marginBottom: CommonStyles.Sizes.MediumSpace,
    marginTop: CommonStyles.Sizes.SmallSpace
});

export const activityLogVerificationPadding = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'verification-padding', {
    paddingBottom: CommonStyles.Sizes.LargeSpace
});

export const activityLogFileVerificationInput = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'text-input', {
    backgroundColor: TabStyles.Colors.White
});

export const activityLogFileVerificationInputLabel = cssClass(ACTIVITY_LOG_SETTINGS_PREFIX, 'text-input-label', {
    textAlign: 'left',
    paddingBottom: CommonStyles.Sizes.DefaultSpace,
});
